module.exports = __webpack_public_path__ + "static/media/brahem3.7f1bc14e.webp";